import type { MessageDescriptor } from 'react-intl';

import { messages } from './messages';

export const FILTER_EVERYTHING = 'everything';
export const FILTER_PREPARING_ORDERS = 'preparing-orders';
export const FILTER_DECIDING_HOW_TO_SHIP = 'deciding-how-to-ship';
export const FILTER_FULFILLING_AT_SCALE = 'fulfilling-at-scale';

export type ToolFilter = {
  key: string;
  label: MessageDescriptor;
};

export const TOOL_FILTERS: ToolFilter[] = [
  { key: FILTER_EVERYTHING, label: messages.filterEverything },
  { key: FILTER_PREPARING_ORDERS, label: messages.filterPreparingOrders },
  { key: FILTER_DECIDING_HOW_TO_SHIP, label: messages.filterDecidingHowToShip },
  { key: FILTER_FULFILLING_AT_SCALE, label: messages.filterFulfillingAtScale },
];
